// Hardcoded list of colors saved on the backend. comming from the legacy `@bufferapp/ui/style/colors`.
export const colors = [
  { color: '#9C2BFF', name: 'Purple' },
  { color: '#D925AC', name: 'Pink' },
  { color: '#E0364F', name: 'Red' },
  { color: '#FF702C', name: 'Orange' },
  { color: '#FADE2A', name: 'Yellow' },
  { color: '#87C221', name: 'Green' },
  { color: '#00C8CF', name: 'Teal' },
  { color: '#1F35B3', name: 'Blue' },
  { color: '#000000', name: 'Black' },
  { color: '#D7AAFF', name: 'Purple light' },
  { color: '#F0A8DE', name: 'Pink light' },
  { color: '#F3AFB9', name: 'Red lighter' },
  { color: '#FFC6AB', name: 'Orange light' },
  { color: '#FDF2AA', name: 'Yellow light' },
  { color: '#CFE7A6', name: 'Green light' },
  { color: '#99E9EC', name: 'Teal light' },
  { color: '#ABB7FF', name: 'Blue light' },
  { color: '#B8B8B8', name: 'Gray' },
]

export function selectColor(usedColors: string[]): string {
  const unusedColor = colors.find(({ color }) => {
    return !usedColors.includes(color)
  })
  if (unusedColor) {
    return unusedColor.color
  }
  const randomIndex = Math.floor(Math.random() * colors.length)
  const randomColor = colors[randomIndex]
  return randomColor.color
}
